
export const vastSettingsJson = {
    "id(required)": 1,
    "video": {
        "mimes(required)": [
            "application/x-mpegURL",
            "video/3gpp",
            "video/quicktime",
            "video/x-ms-wmv",
            "video/mp4",
            "video/x-msvideo",
            "application/javascript"
        ],
        "minduration(required)": 0,
        "maxduration(required)": 90,
        "protocols(required)": [
            1,
            2,
            3,
            7,
            4,
            5,
            6,
            8
        ],
        "w(recommended)": 320,
        "h(recommended)": 480,
        "startdelay(recommended)": 0,
        "battr": [],
        "boxingallowed": 1,
        "playbackmethod": 2,
        "pos": 7,
        "api": [
            1,
            2
        ],
        "ext": {
            "rewarded": 0
        }
    },
    "instl": 0,
    "tagid": 21148,
    "bidfloor": 1.611111,
    "bidfloorcur": "USD",
    "secure": 1
}